var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { useBackgroundContext } from '../BackgroundContext/index.js';
export const Checkbox = forwardRef((props, ref) => {
    const { invalid = false, disabled, placement = 'start', children, className } = props, rest = __rest(props, ["invalid", "disabled", "placement", "children", "className"]);
    const { text500Clsx } = useBackgroundContext();
    const input = (React.createElement("input", Object.assign({ ref: ref, type: "checkbox", className: clsx(' h-4 w-4 rounded', 'text-actionPrimary-600', 'focus:outline-none focus:ring-transparent', !invalid &&
            'focus-visible:ring-actionPrimary-500 border-basicSurface-300/25', invalid &&
            'border-danger-300 focus-visible:ring-danger-500 focus:border-danger-500', disabled && 'opacity-60 cursor-default', className), disabled: disabled }, rest)));
    if (placement === 'start') {
        return (React.createElement("label", { className: "relative flex items-start" },
            React.createElement("div", { className: "flex items-center h-5" }, input),
            React.createElement("div", { className: clsx('ml-3 text-sm', text500Clsx, disabled && 'opacity-60 cursor-default') }, children)));
    }
    return (React.createElement("label", { className: "relative flex items-start" },
        React.createElement("div", { className: clsx('min-w-0 flex-1 text-sm', text500Clsx, disabled && 'opacity-60 cursor-default') }, children),
        React.createElement("div", { className: "ml-3 flex items-center h-5" }, input)));
});
//# sourceMappingURL=Checkbox.js.map